import { keyframes } from '@emotion/react'
import type { CSSObject } from '@emotion/react'

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

/**
 * Applied to top-bar content that mounts in response to navigation or the rail toggling — the
 * back button with the trail, and the logo/mark swap — so it dissolves in rather than popping.
 * A mount-time animation, so a `key` change on the element replays it.
 */
export const topNavFadeInStyles: CSSObject = {
  animation: `${fadeIn} 200ms ease-out both`,
  '@media (prefers-reduced-motion: reduce)': {
    animation: 'none',
  },
}
